import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import type { IBulkReplacementDealsPayload } from '../types';
import {
  AFFILIATE_CHANGE_TRACKER_CONDITION_API_URL,
  AFFILIATE_CHANGE_TRACKER_CONDITION_MUTATION,
  AFFILIATE_TRACKERS_SETTINGS_LIST_QUERY,
  AFFILIATES_APPROVED_TRACKERS_LIST_PERMISSIONS,
} from '../constants';

export default function useChangeTrackerDealsMutation(): IContextMutationResult<void, Error, IBulkReplacementDealsPayload> {
  const { fetchPut } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, IBulkReplacementDealsPayload>({
    mutationKey: [AFFILIATE_CHANGE_TRACKER_CONDITION_MUTATION],
    mutationFn: ({ id, ...payload }) => fetchPut<void>(
      AFFILIATE_CHANGE_TRACKER_CONDITION_API_URL,
      payload,
      {
        permission: AFFILIATES_APPROVED_TRACKERS_LIST_PERMISSIONS.HISTORY_CHANGES_EDIT,
        urlParams: {
          id,
        },
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [AFFILIATE_TRACKERS_SETTINGS_LIST_QUERY] });
      displayPresetToast('edited');
    },
  });
}
